import { render } from "./LaunchBtn.vue?vue&type=template&id=79d2ec5d&scoped=true"
const script = {}

import "./LaunchBtn.vue?vue&type=style&index=0&id=79d2ec5d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d2ec5d"]])

export default __exports__